import imgHankyu71 from "./tipe 7 (1).png";
import imgHankyu72 from "./tipe 7 (2).png";
import imgHankyu73 from "./tipe 7 (3).png";

const imghankyu7 = [imgHankyu71, imgHankyu72, imgHankyu73];
export default imghankyu7;
